import { render, staticRenderFns } from "./SearchBrowseActions.vue?vue&type=template&id=c8993b94&scoped=true"
import script from "./SearchBrowseActions.vue?vue&type=script&lang=ts"
export * from "./SearchBrowseActions.vue?vue&type=script&lang=ts"
import style0 from "./SearchBrowseActions.vue?vue&type=style&index=0&id=c8993b94&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8993b94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8993b94')) {
      api.createRecord('c8993b94', component.options)
    } else {
      api.reload('c8993b94', component.options)
    }
    module.hot.accept("./SearchBrowseActions.vue?vue&type=template&id=c8993b94&scoped=true", function () {
      api.rerender('c8993b94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/SearchBrowseActions.vue"
export default component.exports